import {
  IRecommendedProfessional,
  IRecommendedProfessionalApi,
} from './recommendedProfessionalsTypes';

function toRecommendedProfessionals(
  businessApi: IRecommendedProfessionalApi,
): IRecommendedProfessional {
  return {
    id: businessApi.id,
    profileImage: businessApi.profile_image,
    fullName: businessApi.fullname,
    professions: businessApi.professions,
    activityLevel: businessApi.activity_level,
    rating: businessApi.rating,
    loyaltyLevel: businessApi.loyalty_level,
    averageTimeManagement: businessApi.averageTimeManagement,
    averageInterpersonalSkills: businessApi.averageInterpersonalSkills,
    averageProfessionalSkills: businessApi.averageProfessionalSkills,
    yearsOfExperience: businessApi.years_of_experience,
    completedJobs: businessApi.completed_jobs,
    badges: businessApi.badges ?? [],
    education: businessApi.education ?? {},
  };
}

export const recommendedProfessionalsAdapter = { toRecommendedProfessionals };
